/* istanbul ignore file */
import { TypedUseSelectorHook, useSelector as useSelectorHook } from 'react-redux';
import { RootInitialState } from '../store';

export const useSelector: TypedUseSelectorHook<RootInitialState> = useSelectorHook;
